module.exports = __webpack_public_path__ + "img/icon-gift-oin-card-gray.7f73c5aa.svg";